import React, { Component } from 'react';
import NoAuthComponent from '../auth/NoAuthComponent';
import BasicAuthComponent from '../auth/BasicAuthComponent';
import BearerAuthComponent from '../auth/BearerAuthComponent';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable, changeApiVariableAuth } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaLabel from '../../../../custom/FormicaLabel';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import RoleHelper from '../../../../../RoleHelper';
import ComponentName from '../../../../../constant/ComponentName';
import NavigationUtil from '../../../../../util/NavigationUtil';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiAuthorizationComponent extends Component<Props> {
  render() {
    const { auth } = this.props;
    return (
      <div className={'flex flex-col gap-y-4 w-full h-full py-5 px-2'}>
        <div className={'flex flex-col gap-y-2 lg:w-[400px]'}>
          <FormicaLabel label={LanguageUtil.get({ id: 'common.label.type', defaultMessage: 'Type' })} />
          <FormicaSearchSelectBox
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            options={this.getAuthTypes()}
            onChange={(e: FormicaSelectBoxItem) => {
              this.setAuthType(e.value as AuthType);
            }}
            rounded
            value={auth}
            placeholder={LanguageUtil.get({ id: 'common.label.select', defaultMessage: 'Select' })}
            data-testid={`${ComponentName.API_VARIABLE}_auth_type_select`}
          />
          {auth === AuthType.NO_AUTH && <NoAuthComponent />}
          {auth === AuthType.BASIC && <BasicAuthComponent disabled={!RoleHelper.canEdit('EnrichmentApi')} />}
          {auth === AuthType.BEARER && <BearerAuthComponent disabled={!RoleHelper.canEdit('EnrichmentApi')} />}
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const {
      apiVariable: { apiVariable },
      changeApiVariableAuth,
    } = this.props;
    const token = apiVariable.headers['Authorization'];
    if (token) {
      const tokenType = token.split(' ')[0];
      switch (tokenType) {
        case 'Bearer':
          changeApiVariableAuth(AuthType.BEARER);
          break;
        case 'Basic':
          changeApiVariableAuth(AuthType.BASIC);
          break;
        default:
          changeApiVariableAuth(AuthType.NO_AUTH);
      }
    }
  }

  private setAuthType = (authType: AuthType) => {
    const { changeApiVariableAuth } = this.props;
    changeApiVariableAuth(authType);
  };

  private getAuthTypes = () => {
    return [
      {
        label: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.authorization.noAuth', defaultMessage: 'No Auth' }),
        value: AuthType.NO_AUTH,
      },
      {
        label: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.authorization.basicAuth', defaultMessage: 'Basic Auth' }),
        value: AuthType.BASIC,
      },
      {
        label: LanguageUtil.get({ id: 'pages.enrichment.apiEnrichment.authorization.bearerToken', defaultMessage: 'Bearer Auth' }),
        value: AuthType.BEARER,
      },
    ];
  };
}

interface Props extends ReduxProps {}

export enum AuthType {
  NO_AUTH = 'No Auth',
  BASIC = 'Basic Auth',
  BEARER = 'Bearer Token',
}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  isUpdate: state.apiVariable.isUpdate,
  auth: state.apiVariable.auth,
});

const mapDispatchToProps = { changeApiVariable, changeApiVariableAuth };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiAuthorizationComponent);
